import { useEffect } from 'react';
import { Text } from '@chakra-ui/react';

import { useRegionals, usePaginateRegionals } from 'hooks/regionals';
import { useFilters } from 'hooks/filters';

import AsyncTable from 'components/Tables/AsyncTable';
import StatusIndicator from 'components/StatusIndicator';
import dateFormat from 'functions/dateFormat';

const columns = [
	{
		Header: 'Nome',
		accessor: 'name'
	},
	{
		Header: 'Empresas',
		accessor: 'companies_count'
	},
	{
		Header: 'Beneficiários',
		accessor: 'beneficiaries_count'
	},
	{
		Header: 'Admin Regional',
		accessor: 'admin'
	},
	{
		Header: 'Status',
		accessor: 'is_active',
		Cell: ({ value }) => <StatusIndicator isActive={value} size="sm" />
	},
	{
		Header: 'Data de criação',
		accessor: 'created_at',
		Cell: ({ value }) => <Text>{dateFormat(value)}</Text>
	}
];

const RegionalsTable = () => {
	const { filters } = useFilters();
	const { rows, page, perPage, total, setToDelete, setDeleteModalOpen } =
		useRegionals();
	const [paginateRegionals, { loading }] = usePaginateRegionals();

	const deleteRegional = (id) => {
		setToDelete(id);
		setDeleteModalOpen(true);
	};

	const fetchData = ({ pageSize, pageIndex }) => {
		if (pageSize != perPage) pageIndex = 1;
		paginateRegionals({
			variables: {
				first: pageSize || perPage,
				page: pageIndex || page,
				...filters
			}
		});
	};

	useEffect(() => {
		if (filters && Object.keys(filters).length > 0) {
			paginateRegionals({
				variables: {
					first: perPage,
					page,
					...filters
				}
			});
		}
	}, [filters]);

	return (
		<AsyncTable
			fetchData={fetchData}
			isLoaded={!loading}
			data={!loading ? rows : [{}, {}, {}, {}]}
			columns={columns}
			total={total}
			size={perPage}
			asyncPage={page}
			searchByName
			baseRoute="regionais"
			removeAction={deleteRegional}
			linkRow
		/>
	);
};

export default RegionalsTable;
